"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.videoMachine = void 0;
var xstate_1 = require("xstate");
var lodash_1 = require("lodash");
var use_player_prefs_1 = require("../hooks/use-player-prefs");
exports.videoMachine = (0, xstate_1.createMachine)({
    id: 'videoMachine',
    initial: 'loading',
    context: {
        resource: {},
        viewer: {},
        rootElemRef: null,
        cueFormElemRef: null,
        videoRef: undefined,
        waiting: true,
        duration: 0,
        currentTime: 0,
        seekingTime: undefined,
        hasStarted: false,
        isActive: false,
        readyState: 0,
        volume: 0.8,
        playbackRate: 1,
        isFullscreen: false,
        withSidePanel: true,
        lastAction: undefined,
        seeking: false,
        metadataTracks: [],
        activeCues: [],
        subtitleTracks: [],
        cuesMuted: false,
        writingCueNote: false,
        isSubmittingCueNote: false,
        writingCueNoteVisibility: 'draft',
        shortcutsEnabled: true
    },
    on: {
        SET_ROOT_ELEM: {
            actions: (0, xstate_1.assign)({
                rootElemRef: function (_context, event) { return event.rootElemRef; }
            })
        },
        SET_CUE_FORM_ELEM: {
            actions: (0, xstate_1.assign)({
                cueFormElemRef: function (_context, event) { return event.cueFormElemRef; }
            })
        },
        REGISTER: {
            actions: [
                (0, xstate_1.assign)({
                    videoRef: function (_context, event) { return event.videoRef; },
                    readyState: function (_context, event) { var _a, _b, _c; return (_c = (_b = (_a = event.videoRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.readyState) !== null && _c !== void 0 ? _c : 0; }
                }),
            ]
        },
        WAITING: {
            actions: [
                (0, xstate_1.assign)({
                    waiting: function (_context, _event) { return true; }
                }),
            ]
        },
        WRITE: {
            actions: [
                (0, xstate_1.assign)({
                    writingCueNote: function (context, _event) { return !context.writingCueNote; }
                }),
            ]
        },
        DONE_WAITING: {
            actions: [
                (0, xstate_1.assign)({
                    waiting: function (_context, _event) { return false; }
                }),
            ]
        },
        ACTIVITY: {
            actions: [
                (0, xstate_1.assign)({
                    isActive: function (_context, _event) { return true; }
                }),
            ]
        },
        TOGGLE_FULLSCREEN: {
            actions: [
                (0, xstate_1.assign)({
                    isFullscreen: function (_context, _event) { return true; },
                    withSidePanel: function (_context) { return false; }
                }),
                'toggleFullscreen',
            ]
        },
        EXIT_FULLSCREEN: {
            actions: [
                (0, xstate_1.assign)({
                    isFullscreen: function (_context) { return false; },
                    withSidePanel: function (_context) {
                        var theater = (0, use_player_prefs_1.getPlayerPrefs)().theater;
                        return theater;
                    }
                }),
                'exitFullscreen',
            ]
        },
        TOGGLE_SIDE_PANEL: {
            actions: [
                (0, xstate_1.assign)({
                    withSidePanel: function (context, _event) { return !context.withSidePanel; }
                }),
            ]
        },
        CLEAR_SUBTITLES_TRACKS: {
            actions: [
                (0, xstate_1.assign)({
                    subtitleTracks: function (context, _event) {
                        var videoRef = context.videoRef;
                        var subtitles = Array.from((videoRef === null || videoRef === void 0 ? void 0 : videoRef.current.textTracks) || []).filter(function (track) {
                            return ['subtitles'].includes(track.kind);
                        });
                        subtitles.forEach(function (track) {
                            track.mode = 'disabled';
                        });
                        return [];
                    }
                }),
                function (_context, _event) {
                    (0, use_player_prefs_1.savePlayerPrefs)({ subtitle: {} });
                },
            ]
        },
        ACTIVATE_SUBTITLES_TRACK: {
            actions: [
                (0, xstate_1.assign)({
                    subtitleTracks: function (_context, event) {
                        event.track.mode = 'showing';
                        return [event.track];
                    }
                }),
                'saveSubtitlePreference',
            ]
        },
        CLEAR_METADATA_TRACKS: {
            actions: [
                (0, xstate_1.assign)({
                    metadataTracks: function (_context, _event) { return []; },
                    activeCues: function (_context, _event) { return []; }
                }),
            ]
        },
        ACTIVATE_METADATA_TRACK: {
            actions: [
                (0, xstate_1.assign)({
                    metadataTracks: function (context, event) {
                        event.track.mode = 'showing';
                        if (context.metadataTracks.indexOf(event.track) < 0) {
                            context.metadataTracks.push(event.track);
                        }
                        return __spreadArray([], context.metadataTracks, true);
                    }
                }),
            ]
        },
        DELETE_CUE: {
            target: 'deleting_note',
            actions: [
                (0, xstate_1.assign)({
                    metadataTracks: function (context, event) {
                        context.metadataTracks.forEach(function (track) {
                            return track.removeCue(event.cue);
                        });
                        return context.metadataTracks;
                    }
                }),
            ]
        },
        ACTIVATE_CUE: {
            actions: [
                (0, xstate_1.assign)({
                    activeCues: function (context, event) {
                        //TODO: Gracefully handle multiple active cues
                        return context.activeCues.includes(event.cue)
                            ? context.activeCues
                            : __spreadArray(__spreadArray([], context.activeCues, true), [event.cue], false);
                    }
                }),
            ]
        },
        DEACTIVATE_CUE: {
            actions: [
                (0, xstate_1.assign)({
                    activeCues: function (context, event) {
                        (0, lodash_1.remove)(context.activeCues, function (cue) {
                            return (0, lodash_1.isEqual)(event.cue, cue);
                        });
                        return __spreadArray([], context.activeCues, true);
                    }
                }),
            ]
        },
        CLEAR_CUES: {
            actions: [
                (0, xstate_1.assign)({
                    activeCues: function (_context, _event) { return []; }
                }),
            ]
        },
        TOGGLE_MUTE_CUES: {
            actions: [
                (0, xstate_1.assign)({
                    cuesMuted: function (context, _event) { return !context.cuesMuted; }
                }),
            ]
        },
        TOGGLE_CUE_STATE: {
            actions: [
                // TODO: Save user preference
                (0, xstate_1.assign)({
                    writingCueNoteVisibility: function (_context, event) { return event.visibility; }
                }),
            ]
        },
        SEEKING: {
            actions: [
                (0, xstate_1.assign)({
                    seekingTime: function (context, event) { return event.seekingTime; },
                    currentTime: function (_context, event) { return event.seekingTime; },
                    seeking: function (_context, _event) { return true; },
                    hasStarted: function (_context, _event) { return true; }
                }),
                'seekVideo',
            ]
        },
        END_SEEKING: {
            actions: [
                (0, xstate_1.assign)({
                    seekingTime: function (_context, _event) { return 0; },
                    seeking: function (_context, _event) { return false; }
                }),
            ]
        },
        TOGGLE_SHORTCUTS_ENABLED: {
            actions: [
                (0, xstate_1.assign)({
                    shortcutsEnabled: function (context, _event) { return !context.shortcutsEnabled; }
                }),
            ]
        }
    },
    states: {
        loading: {
            entry: [
                (0, xstate_1.assign)({
                    waiting: function (_context, _event) { return true; },
                    playbackRate: function (_context, _event) { return (0, use_player_prefs_1.getPlayerPrefs)().playbackRate; }
                }),
            ],
            invoke: [
                {
                    id: 'fetchLessonDataService',
                    src: 'loadResource',
                    onDone: {
                        actions: [
                            (0, xstate_1.assign)({
                                resource: function (_context, event) {
                                    if (event.type !== 'done.invoke.fetchLessonDataService')
                                        return {};
                                    return { lesson: event.data };
                                },
                                readyState: function (context, _event) { var _a, _b, _c; return (_c = (_b = (_a = context.videoRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.readyState) !== null && _c !== void 0 ? _c : 0; }
                            }),
                        ]
                    }
                },
                {
                    id: 'fetchViewerService',
                    src: 'loadViewer',
                    onDone: {
                        actions: [
                            (0, xstate_1.assign)({
                                viewer: function (_context, event) {
                                    if (event.type !== 'done.invoke.fetchViewerService')
                                        return {};
                                    return event.data;
                                }
                            }),
                        ]
                    }
                },
            ],
            on: {
                LOAD_RESOURCE: {
                    target: 'loading',
                    actions: (0, xstate_1.assign)({
                        resource: function (_context, event) { return event.resource; }
                    })
                },
                LOADED: {
                    target: 'ready',
                    actions: (0, xstate_1.assign)({
                        readyState: function (context, _event) { var _a, _b, _c; return (_c = (_b = (_a = context.videoRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.readyState) !== null && _c !== void 0 ? _c : 0; },
                        waiting: function (_context, _event) { return false; }
                    })
                },
                FAIL: 'failure'
            }
        },
        ready: {
            initial: 'paused',
            entry: [
                (0, xstate_1.assign)({
                    waiting: function (_context, _event) { return false; },
                    isSubmittingCueNote: function (_context, _event) { return false; },
                    shortcutsEnabled: function (_context, _event) { return true; }
                }),
            ],
            on: {
                LOAD_RESOURCE: {
                    target: 'loading',
                    actions: (0, xstate_1.assign)({
                        resource: function (_context, event) { return event.resource; }
                    })
                },
                TAKE_NOTE: {
                    target: 'taking_note',
                    actions: [
                        (0, xstate_1.assign)({
                            shortcutsEnabled: function (_context, _event) { return false; }
                        }),
                    ]
                },
                VOLUME_CHANGE: {
                    actions: [
                        (0, xstate_1.assign)({
                            volume: function (_context, event) { return event.volume; }
                        }),
                        'setVolume',
                    ]
                },
                TOGGLE_MUTE: {
                    actions: ['toggleMute']
                },
                PLAYBACKRATE_CHANGE: {
                    actions: [
                        (0, xstate_1.assign)({
                            playbackRate: function (_context, event) { return event.playbackRate; }
                        }),
                        'setPlaybackRate',
                    ]
                }
            },
            states: {
                paused: {
                    on: {
                        PLAY: {
                            target: 'playing',
                            actions: [
                                (0, xstate_1.assign)({
                                    hasStarted: function (_context, _event) { return true; },
                                    lastAction: function (_context, _event) { return 'PLAY'; }
                                }),
                                'playVideo',
                            ]
                        }
                    }
                },
                playing: {
                    entry: [
                        (0, xstate_1.assign)({
                            waiting: function (_context, _event) { return false; }
                        }),
                    ],
                    on: {
                        PAUSE: {
                            target: 'paused',
                            actions: [
                                'pauseVideo',
                                (0, xstate_1.assign)({
                                    lastAction: function (_context, _event) { return 'PAUSE'; }
                                }),
                            ]
                        },
                        TIMING: {
                            actions: (0, xstate_1.assign)({
                                currentTime: function (context, _event) { var _a, _b, _c; return (_c = (_b = (_a = context.videoRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.currentTime) !== null && _c !== void 0 ? _c : 0; },
                                duration: function (context, _event) { var _a, _b, _c; return (_c = (_b = (_a = context.videoRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.duration) !== null && _c !== void 0 ? _c : 0; }
                            })
                        },
                        END: 'ended'
                    }
                },
                ended: {
                    entry: ['onVideoEnded'],
                    on: {
                        PLAY: {
                            target: 'playing',
                            cond: function (context, _event) { return !context.waiting; },
                            actions: [
                                (0, xstate_1.assign)({
                                    hasStarted: function (_context, _event) { return true; }
                                }),
                                'playVideo',
                            ]
                        }
                    }
                }
            }
        },
        deleting_note: {
            invoke: {
                src: 'deleteCueNote',
                onDone: [
                    {
                        target: 'ready.playing',
                        cond: function (context) { return context.lastAction === 'PLAY'; },
                        actions: [
                            (0, xstate_1.assign)({
                                hasStarted: function (_context, _event) { return true; }
                            }),
                            'playVideo',
                        ]
                    },
                    {
                        target: 'ready',
                        cond: function (context) { return context.lastAction !== 'PLAY'; }
                    },
                ]
            }
        },
        taking_note: {
            initial: 'focused',
            on: {
                SUBMITTED: {
                    target: 'taking_note.submitting',
                    actions: [
                        (0, xstate_1.assign)({
                            isSubmittingCueNote: function (_context, _event) { return true; }
                        }),
                    ]
                },
                DONE_SUBMITTING_NOTE: [
                    {
                        target: 'ready.playing',
                        cond: function (context) { return context.lastAction === 'PLAY'; },
                        actions: [
                            (0, xstate_1.assign)({
                                isSubmittingCueNote: function (_context, _event) { return false; },
                                hasStarted: function (_context, _event) { return true; },
                                metadataTracks: function (context, event) {
                                    context.metadataTracks[0].addCue(event.cue);
                                    return context.metadataTracks;
                                }
                            }),
                            'playVideo',
                        ]
                    },
                    {
                        target: 'ready',
                        cond: function (context) { return context.lastAction !== 'PLAY'; },
                        actions: [
                            (0, xstate_1.assign)({
                                isSubmittingCueNote: function (_context, _event) { return false; },
                                metadataTracks: function (context, event) {
                                    context.metadataTracks[0].addCue(event.cue);
                                    return context.metadataTracks;
                                }
                            }),
                        ]
                    },
                ],
                FAIL: {
                    target: 'taking_note.failure',
                    actions: [
                        (0, xstate_1.assign)({
                            isSubmittingCueNote: function (_context, _event) { return false; }
                        }),
                    ]
                },
                CANCELLED: {
                    target: 'ready'
                }
            },
            states: {
                focused: {
                    on: {
                        CHANGE: {
                            target: 'typing'
                        }
                    }
                },
                typing: {
                    entry: ['pauseVideo']
                },
                submitting: {
                    invoke: {
                        src: 'addCueNote',
                        autoForward: true,
                        onDone: {
                            actions: [
                                (0, xstate_1.assign)({
                                    isSubmittingCueNote: function (_context, _event) { return false; }
                                }),
                            ]
                        }
                    }
                },
                failure: {}
            }
        },
        failure: {
            entry: [
                (0, xstate_1.assign)({
                    waiting: function (_context, _event) { return true; }
                }),
            ]
        }
    }
});
